import { render } from "./DigitalInputUsageSetting.vue?vue&type=template&id=1a4e9a93"
import script from "./DigitalInputUsageSetting.vue?vue&type=script&lang=js"
export * from "./DigitalInputUsageSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__